(function () {
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.closest || !form.closest('.yp-card__form')) return;
      var button = form.querySelector('.yp-card__btn');
      if (!button || button.getAttribute('aria-disabled') === 'true') return;

      var sawLoading = false;
      var observer = new MutationObserver(function () {
        if (button.classList.contains('loading')) {
          sawLoading = true;
          return;
        }
        if (!sawLoading) return;
        observer.disconnect();
        if (button.getAttribute('aria-disabled') === 'true') return;

        button.setAttribute('data-state', 'added');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          bubble.classList.remove('yp-bump');
          void bubble.offsetWidth;
          bubble.classList.add('yp-bump');
        }
        setTimeout(function () {
          button.removeAttribute('data-state');
          if (bubble) bubble.classList.remove('yp-bump');
        }, 1800);
      });
      observer.observe(button, { attributes: true, attributeFilter: ['class'] });
      setTimeout(function () {
        observer.disconnect();
      }, 15000);
    },
    true
  );
})();
